import styled from 'styled-components';

export const DashboardContainer = styled.div`
  width: 100%;
  height: 100%;
  padding: 20px;
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

export const ChartsContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
  width: 100%;
  
  .row {
    display: flex;
    width: 100%;
    gap: 20px;
    flex-wrap: wrap;
  }

  .col {
    flex: 1;
    min-width: 300px;
  }
`;

export const Section = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  background: #fff; /* Assuming a white background for cards, adjust if needed based on theme */
  border-radius: 8px;
  padding: 15px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.1);
  
  h3 {
    text-align: center;
    margin-bottom: 15px;
    font-size: 1.2rem;
  }
`;

export const LoginMessage = styled.p`
  color: ${(props) => props.theme.errorColor || 'red'};
  text-align: center;
  font-size: 1.2rem;
  width: 100%;
`;

export const CardWrapper = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 20px;
  width: 100%;
  margin-bottom: 20px;
`;
